import { createSlice } from '@reduxjs/toolkit'

export const LoadingStore = createSlice({
  name: 'newsStore',
  initialState: {
    loading: [],
  },
  reducers: {
    setLoading: (state: any, actions: any) => {
      let loadingOle = state.loading;
      if (loadingOle.indexOf(actions?.payload?.value) > -1) {
        loadingOle = loadingOle.filter((item: any) => {
          if (item !== actions?.payload?.value) {
            return item;
          }
        })
      } else {
        loadingOle.push(actions?.payload?.value)
      }
      state.loading = [...loadingOle]
    },
  }
})

export const { setLoading } = LoadingStore.actions

export default LoadingStore.reducer